<template>
  <div
    class="line-clamp-1 max-h-6 w-fit rounded-full px-2 py-[2px] text-sm"
    :class="[variantBackgroundMap[variant], variantTextMap[variant]]"
  >
    <slot />
  </div>
</template>
<script setup lang="ts">
import type { Variant } from '../variant';

withDefaults(defineProps<{ variant: Variant }>(), {
  variant: 'primary',
});

const variantBackgroundMap: Record<Variant, string> = {
  neutral: 'bg-neutral-500',
  primary: 'bg-primary-500',
  secondary: 'bg-secondary-500',
  danger: 'bg-danger-500',
  success: 'bg-success-500',
  tertiary: 'bg-tertiary-500',
  quarternary: 'bg-quarternary-500',
};

const variantTextMap: Record<Variant, string> = {
  neutral: 'text-neutral-900',
  primary: 'text-white',
  secondary: 'text-neutral-900',
  danger: 'text-white',
  success: 'text-success-100',
  tertiary: 'text-tertiary-800',
  quarternary: 'text-quarternary-100',
};
</script>
